import Dialog from "@mui/material/Dialog";
import { useContext, useEffect, useState } from "react";
import { useEmbarqueDependencias } from "../../contexts/EmbarqueDependenciasContext.tsx";
import RequestControllerRedux from "../../contexts/RequestController.js";
import TabelaRedux from "../../contexts/Tabela.js";
import CustomButtonV2 from "../CustomButtonV2/CustomButtonV2.js";
import LoadingBar from "../LoadingBar/LoadingBar.js";
import ModalCadastro from "../ModalCadastro/ModalCadastro.tsx";
import "../ModalLancarMeioPagamento/ModalLancarMeioPagamento.css";
import NewIcon from "../NewIcon/NewIcon.js";
import SelectEmbarqueV2 from "../SelectEmbarqueV2/SelectEmbarqueV2.js";

export interface SimpleDialogProps {
	titulo: string;
	tituloBotao: string;
	tituloConfirmar: string;
	texto: string;
	dataAlteracao: string;
	open: boolean;
	onClose: () => void;
	onClick: () => void;
	setMeioPagamento1: (e) => void;
	setMeioPagamento2: (e) => void;
}

function ModalLancarMeioPagamento(props: SimpleDialogProps) {
	const { setDadosRequestControllerRedux } = useContext(RequestControllerRedux);

	const { meioPagamento } = useEmbarqueDependencias();

	const { tabelaRedux } = useContext(TabelaRedux);

	const { onClose, open, onClick } = props;

	const [values, setValues] = useState<any>([]);

	const [valuesSelect, setValuesSelect] = useState<any>([]);

	const handleClose = () => {
		onClose();
	};

	const handleClick = () => {
		onClick();
	};

	const clearMeioPagamento = () => {
		setValuesSelect((current) => ({ ...current, meioPagamento: "" }));
		setValues((current) => ({ ...current, meioPagamento: "" }));
		setValues((current) => ({ ...current, meioPagamentoId: null }));
	};

	const clearMeioPagamento2 = () => {
		setValuesSelect((current) => ({ ...current, meioPagamento2: "" }));
		setValues((current) => ({ ...current, meioPagamento2: "" }));
		setValues((current) => ({ ...current, meioPagamento2Id: null }));
	};

	const [idAtual, setIdAtual] = useState(0);

	const [disable, setDisable] = useState(false);

	const [openCadastroMeioPagamento, setOpenCadastroMeioPagamento] =
		useState(false);

	const [loadingSelectMeioPagamento, setLoadingSelectMeioPagamento] =
		useState(false);

	useEffect(() => {
		const meioPagamentoSelecionado = meioPagamento?.find(
			(option) => option.nome === tabelaRedux?.row?.meioPagamento,
		);
		if (meioPagamentoSelecionado) {
			setValuesSelect((current) => ({
				...current,
				meioPagamento: {
					value: meioPagamentoSelecionado.nome,
					label: meioPagamentoSelecionado.nome,
					id: meioPagamentoSelecionado.idMeioPagamento,
				},
			}));
			setValues((current) => ({
				...current,
				meioPagamentoId: meioPagamentoSelecionado.idMeioPagamento,
			}));
			props.setMeioPagamento1(meioPagamentoSelecionado.idMeioPagamento);
		}
		const meioPagamento2Selecionado = meioPagamento?.find(
			(option) => option.nome === tabelaRedux?.row?.meioPagamento2,
		);
		if (meioPagamento2Selecionado) {
			setValuesSelect((current) => ({
				...current,
				meioPagamento2: {
					value: meioPagamento2Selecionado.nome,
					label: meioPagamento2Selecionado.nome,
					id: meioPagamento2Selecionado.idMeioPagamento2,
				},
			}));
			setValues((current) => ({
				...current,
				meioPagamento2Id: meioPagamento2Selecionado.idMeioPagamento2,
			}));
			props.setMeioPagamento2(meioPagamento2Selecionado.idMeioPagamento2);
		}
	}, [tabelaRedux]);

	useEffect(() => {
		setLoadingSelectMeioPagamento(true);
		setTimeout(() => {
			setLoadingSelectMeioPagamento(false);
		}, 1000);
	}, [meioPagamento]);

	const handleCloseCadastroMeioPagamento = () => {
		if (idAtual) {
			setOpenCadastroMeioPagamento(false);
			setDadosRequestControllerRedux("Close MeioPagamento");
		} else {
			setDadosRequestControllerRedux("Close MeioPagamento");
			setOpenCadastroMeioPagamento(false);
		}
	};

	return (
		<Dialog open={open} onClose={handleClose}>
			<div className="content-container">
				<div className="div-modal-usuario-titulo">{props.titulo}</div>
				<div className="modal-lancar-meio-pagamento-body">
					{loadingSelectMeioPagamento ? (
						<LoadingBar />
					) : (
						<div className="coluna-emb">
							<div>
								<p className="input-label-emb">Meio Pagamento:</p>
								<SelectEmbarqueV2
									classeCss={161}
									onChange={(e) => {
										setValuesSelect((current) => ({
											...current,
											meioPagamento: e,
										}));
										setValues((current) => ({
											...current,
											meioPagamento: e.value,
										}));
										setValues((current) => ({
											...current,
											meioPagamentoId: e.id,
										}));
										props.setMeioPagamento1(e.id);
									}}
									clearSelection={clearMeioPagamento}
									onInfoIconClick={setIdAtual}
									pequeno={true}
									id="idMeioPagamento"
									value={valuesSelect.meioPagamento}
									titulo="Meio de Pagamento"
									dadosSelect={meioPagamento}
									referenciaId="nome"
									referenciaItem="nome"
								/>
							</div>
							<NewIcon
								onClick={(e) => {
									setOpenCadastroMeioPagamento(true);
									setIdAtual(0);
									setDisable(false);
								}}
							/>
						</div>
					)}
					{loadingSelectMeioPagamento ? (
						<LoadingBar />
					) : (
						<div className="coluna-emb">
							<div>
								<p className="input-label-emb">Meio Pagamento 2:</p>
								<SelectEmbarqueV2
									classeCss={161}
									onChange={(e) => {
										setValuesSelect((current) => ({
											...current,
											meioPagamento2: e,
										}));
										setValues((current) => ({
											...current,
											meioPagamento2: e.value,
										}));
										setValues((current) => ({
											...current,
											meioPagamento2Id: e.id,
										}));
										props.setMeioPagamento2(e.id);
									}}
									clearSelection={clearMeioPagamento2}
									onInfoIconClick={setIdAtual}
									pequeno={true}
									id="idMeioPagamento"
									value={valuesSelect.meioPagamento2}
									titulo="Meio de Pagamento 2"
									dadosSelect={meioPagamento}
									referenciaId="nome"
									referenciaItem="nome"
								/>
							</div>
							<NewIcon
								onClick={(e) => {
									setOpenCadastroMeioPagamento(true);
									setIdAtual(0);
									setDisable(false);
								}}
							/>
						</div>
					)}
				</div>
			</div>
			<div className="footer-container">
				<CustomButtonV2
					classCss="custom-button-cadastrar"
					classText="button-texto-cadastrar"
					titulo="OK"
					cor="#0946B8"
					onClick={handleClick}
				/>
				<CustomButtonV2
					classCss="custom-button-cancelar"
					classText="button-texto-cancelar"
					titulo="Cancelar"
					cor="#0946B8"
					onClick={handleClose}
				/>
			</div>
			<ModalCadastro
				titulo="Cadastro"
				tituloConfirmar="OK"
				cadastroMeioPagamento="sim"
				open={openCadastroMeioPagamento}
				idAtual={idAtual}
				desabilitar={disable}
				onClose={handleCloseCadastroMeioPagamento}
			/>
		</Dialog>
	);
}

export default ModalLancarMeioPagamento;
